<template>
    <section class="impersonation-modal-wrapper">
      <section class="impersonation-modal">
        <close-icon class="close-btn clickable" @click="close" fillColor="#333"/>
<!--        <div v-if="passwordError">-->
<!--          <h2>Invalid Password</h2>-->
<!--          <p>The password you entered was incorrect</p>-->
<!--          <button @click="confirmPasswordError" class="popup-confirm-btn btn-primary">Ok</button>-->
<!--        </div>-->
        <div v-if="!impersonating">
          <h2>Become User</h2>
          <p>Enter <strong>your own password</strong> to become this user</p>

          <label>
            <span v-if="passwordError" class="password-error-msg">Incorrect password.  Check password and try again.</span>
            <span>Password:</span>
            <input name="impersonate_password" v-model="adminPassword" type="password" />
          </label>
          <div class="impersonation-modal-btn-group">
            <button @click="close" class="popup-cancel-btn btn-secondary">Cancel</button>
            <button @click="impersonate(adminPassword)" class="popup-confirm-btn btn-primary">Become User</button>
          </div>
        </div>
        <div v-if="impersonating">
          <h2>Become User</h2>
          <p>You are now working as {{user.firstname}} {{user.lastname}}.  The site will reload to their dashboard now.</p>
          <button @click="reload" class="popup-confirm-btn btn-primary">Ok</button>
        </div>
      </section>
    </section>
</template>

<script>
import './impersonate-modal.scss';
import {isObject} from 'lodash';
import {CloseIcon} from '../../icons.js';


export default {
    name: "AccountUsersModal",

    props: {

      user: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },

    components: {
      CloseIcon,
    },

    computed: {},

    methods: {

      confirmPasswordError () {
        this.passwordError = false;
        this.adminPassword = '';
      },

      close () {
        this.$emit('close');
      },

      reload () {
        window.location.href = '/dashboard';
      },

      impersonate (adminPassword) {
        let params = {
          action: 'become-user',
          admin_password: adminPassword,
          target_user: this.user.id
        };

        axios.post('/impersonate', params).then(result => {
          let data = result.data;

          //show error modal
          if (
            isObject(data)
            && (data.status == 'bad_password' || data.status == 'error'))
          {
            setTimeout(() => this.passwordError = false, 4000);
            return this.passwordError = true;
          }

          //impersonating user
          this.passwordError = false;
          this.impersonating = true;

          //reload page to dashboard
          setTimeout(() => {
            this.reload();
          }, 3000)
        });
      },
    },

    data () {

        return {
          passwordError: false,
          impersonating: false,
          adminPassword: '',
        }
    }
}
</script>
